module.exports = __webpack_public_path__ + "images/assets/99b62da172480e751d51467036d6e883.svg";